import {initTooltips} from './functions';
import axios from 'axios';
import initCalendar from "./calendar";
import initBooking from "./booking";

axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

interface PageInfo {
	type: 'GET' | 'POST',
	routeName?: string,
	path: string[]
}

declare global {
	const page: PageInfo;
}

window.addEventListener("load", () => {

	// Tooltips
	initTooltips(document);

	// Calendar
	initCalendar();

	// Pages
	if (page.routeName && page.routeName === 'dashboard') {
		initBooking();
	}
});

